module.exports = __webpack_public_path__ + "img/tarjeta_soon.b3df1703.png";